import styled, { keyframes } from 'styled-components';
const fadeIn = keyframes(["from{opacity:0;}to{opacity:1;}"]);
const UITourPulserLayer = styled.svg.attrs(props => ({
  // This is for preventing generating duplicate style in renderings
  style: {
    zIndex: props.zIndex
  }
})).withConfig({
  displayName: "UITourPulserLayer"
})([".hs-private.hs-private.hs-private &{animation:", " 0.3s ease-out forwards;height:100vh;left:0;overflow:hidden;pointer-events:none;position:fixed;top:0;width:100vw;}.hs-private.hs-private.hs-private & .tour-pulser-overlay{pointer-events:all;}"], fadeIn);
export default UITourPulserLayer;